const IMAGES = [
    require("./1.webp"),
    require("./2.webp"),
]

export default IMAGES;
